module.exports = __webpack_public_path__ + "447cb78dfeb10fab8bdc1373b903c380.png";